"use client";

import React from "react";
import brandLogo from "assets/img/poln_logo_teal.svg";
import {Slide, TextField, Button, Dialog, Grid, CircularProgress, Alert} from "@mui/material";
import {styled} from '@mui/material/styles';
import {useWaitListForm} from "./useWaitListForm"; // Import the custom hook
import { Player } from "@lottiefiles/react-lottie-player";
import mailSend3 from '../../assets/mail_modal/main_animation_3.json'
import Image from "next/dist/client/legacy/image";
import alreadyRegisterImg from '../../assets/img/alreadyRegistered.png'
import '../../assets/styles/scss/_waitlist_modal.scss'
import { useMediaQuery } from "@mui/material";
import ParseHtml from "../ParseHtml";


const StyledTextField = styled(TextField)(({theme}) => ({
    width: '100%'
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function Header({title, logo = brandLogo, success, htmlSuccessTitleHeading}) {
    return (
        <div style={{display: 'flex', justifyContent: 'space-between', flexDirection: 'column', paddingBottom: '0px'}}>
            {
                success?
                    <div>
                        {/*
                            This component get html form hygraph and render it in React
                        */}
                        {/*<ParseHtml text={htmlSuccessTitleHeading} />*/}
                        <h2 style={{marginTop: '10px'}} className="text-center waitlist-modal-title">{title}</h2>
                    </div>
                    :
                    <h2 className="text-center waitlist-modal-title">{title}</h2>
            }
        </div>
    );
}

export default function WaitListForm(props) {
    const {
        id,
        reverse,
        className,
        openDialog,
        text,
        onClose,
        open,
        title,
        actionText,
        message,
        persona = "Publisher",
        successMessage,
        successTitle,
        campaignName,
        logo,
        nameRequired = true,
        alreadyMessage = "We will be in touch soon",
        alreadyTitle = "Thanks! You have already signed up",
        htmlSuccessTitleHeading
    } = props;

    // Use the custom form handling hook
    const {
        name,
        setName,
        email,
        setEmail,
        emailError,
        success,
        setSuccess,
        error,
        errorCode,
        showLoader,
        resetAndClose,
        handleForm
    } = useWaitListForm({persona, campaignName, onClose});


    const tempError = (errorCode == 100); // the user already exists
    const sTitle = tempError ? alreadyTitle : success ? successTitle : title
    const sMessage = tempError ? alreadyMessage : success ? successMessage : message
    const sActionText = (tempError || success) ? "Done" : actionText
    const activeForm = !(success || tempError)

    const isSmallScreen = useMediaQuery("(max-width:575px)");

    return (
        <div>
            <div className={`d-flex ${reverse ? "justify-content-start" : "justify-content-end"} mt-4 mb-4 mr-10`}>
                <div
                    onClick={openDialog}
                    className={`theme-btn wow fadeInUp rounded-pill cursor-pointer ${className}`}
                    data-wow-duration="1s"
                    id={id}
                >
                    {text}
                </div>
            </div>
            <Dialog
                TransitionComponent={Transition}
                disableScrollLock={true}
                BackdropProps={{
                    style: {backgroundColor: "rgba(0, 0, 0, 0.2)"} // Semi-transparent backdrop
                }}
                PaperProps={{
                    sx: {
                        bgcolor: "rgba(255, 255, 255, 0.9)", // Transparent modal background
                        backdropFilter: "blur(10px)", // Glassmorphism effect
                        boxShadow: 24,
                        borderRadius: 2,
                        padding: {xs: 0, md: 2},
                        width: {xs: '100%', md: '70%',lg: '40%', xl: '600px'},
                        opacity: 0.95
                    }
                }}
                onClose={resetAndClose}
                open={Boolean(open)}
                maxWidth={false}
            >
                <div style={{margin: 16}}>
                    {
                        success &&
                        <Player
                            src={mailSend3}
                            autoplay
                            keepLastFrame
                            style={{ width: 250, height: 250, padding: 0 }}
                        />
                    }
                    {
                        tempError &&
                        <p className="text-center"><Image src={alreadyRegisterImg} alt={'already-registered-img'} width={200} height={200} /></p>
                    }
                    <Header title={sTitle} logo={logo} success={success} htmlSuccessTitleHeading={htmlSuccessTitleHeading} />
                    <p className="waitlist-modal-message" style={{marginBottom: 8, textAlign: 'center' }}>{sMessage}</p>
                    <Grid container spacing={2} padding={2}>
                        {error && (
                            <Grid item xs={12}>
                                <Alert severity="error">{error}</Alert>
                            </Grid>
                        )}
                        {activeForm && <>
                            {nameRequired && (
                                <Grid item xs={12}>
                                    <StyledTextField
                                        label="Your Name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        variant="outlined"
                                        size={isSmallScreen && 'small'}
                                    />
                                </Grid>
                            )}
                            <Grid item xs={12}>
                                <StyledTextField
                                    label="Email"
                                    error={Boolean(emailError)}
                                    helperText={emailError}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    variant="outlined"
                                    size={isSmallScreen && 'small'}
                                />
                            </Grid>
                        </>
                        }
                        <Grid item xs={12} display="flex" justifyContent="center">
                            {showLoader ? (
                                <CircularProgress size={30}/>
                            ) : (
                                <Button
                                    id="consumer-submit-poln"
                                    className="theme-btn red-color rounded-pill"
                                    variant="contained"
                                    onClick={activeForm ? handleForm: resetAndClose}
                                >
                                    {sActionText}
                                </Button>
                            )}
                        </Grid>
                    </Grid>
                </div>
            </Dialog>
        </div>
    );
}
